import React from 'react'
import style from '../card.module.css'

function Test2() {
  return (
    <div className={style.prepration_card}>
     <h3>Airforce Y Super 30</h3>
        <button>Free</button> 
        <div>
        <p>Test 2 . Mar 25, 9:23 PM</p>      
        </div>      
    </div>
  )
}

export default Test2